/**
 * useTokenRefresh Hook
 * Automatically refreshes JWT tokens before expiration
 */

import { useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { scheduleTokenRefresh, clearTokens } from '../utils/tokenManager';

export function useTokenRefresh() {
  const navigate = useNavigate();
  const cleanupRef = useRef(null);

  const handleRefreshSuccess = useCallback((newToken) => {
    console.log('[useTokenRefresh] Token refreshed successfully');
    // Token is already saved by tokenManager, just log success
  }, []);

  const handleRefreshFailure = useCallback((error) => {
    console.error('[useTokenRefresh] Token refresh failed:', error);
    // Clear tokens and redirect to login
    clearTokens();
    navigate('/login', { 
      state: { 
        message: 'Your session has expired. Please log in again.',
        redirectFrom: window.location.pathname
      }
    });
  }, [navigate]);

  useEffect(() => {
    // Start automatic token refresh scheduling
    cleanupRef.current = scheduleTokenRefresh(
      handleRefreshSuccess,
      handleRefreshFailure
    );

    // Cleanup on unmount
    return () => {
      if (cleanupRef.current) {
        cleanupRef.current();
      }
    };
  }, [handleRefreshSuccess, handleRefreshFailure]);

  return null;
}

export default useTokenRefresh;
